import React from "react";
import { connect } from "react-redux";

import styles from '../../../styles/Components/Shared/ConfirmForm.module.css';
import { removeFeaturedPromotion } from "../../../redux/actions/promotions";

const DeleteForm = ({
    handleClose,
    removeFeaturedPromotion,
    updatedData,
    selectedContent,
}) => {
    
    const handleDelete = () => {
        removeFeaturedPromotion(selectedContent.featuredId, updatedData)
        handleClose()
    }

    return (
        <div className={styles.confirm_modal_container}>
          <p className={styles.confirm_modal_header}>DELETE FEATURED CONTENT</p>
          <div>
              <p className={styles.confirm_modal_text}>Are you sure you want to delete?</p>
              <p className={styles.confirm_modal_bold}>This cannot be undone.</p>
          </div>
          <div className={styles.confirm_modal_button_container}>
              <button  className={styles.confirm_modal_buttons} onClick={handleClose}>Cancel</button>
              <button  className={styles.confirm_modal_buttons} onClick={handleDelete}>Delete</button>
          </div>
      </div>
    );
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, { 
    removeFeaturedPromotion,
 })(DeleteForm);
